import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../app/SliceUtils";

export const putSetting = createAsyncThunk(
    '/api/admin/updateSetting',
    (settingKeyValue, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/admin/updateSetting`, method: 'PUT', body: settingKeyValue }, rejectWithValue)
);

export const putImageSetting = createAsyncThunk(
    '/api/admin/updateImageSetting',
    (imgStgKeyValue, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/admin/updateImageSetting`, method: 'PUT', body: imgStgKeyValue }, rejectWithValue)
);

export const fetchAllNavSettings = createAsyncThunk(
    '/api/admin/navSettings',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/admin/navSettings`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const putAllNavSettings = createAsyncThunk(
    '/api/admin/updateNavSettings',
    (updatedNavSettings, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/admin/updateNavSettings`, method: 'PUT', body: updatedNavSettings }, rejectWithValue)
);

export const fetchMoveImagesToAzure = createAsyncThunk(
    '/api/file/update/imageType',
    (imageType, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/file/update/${imageType}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchExternalConnectionSettings = createAsyncThunk(
    '/api/admin/externalConnections',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/admin/externalConnections`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postBulkMoments = createAsyncThunk(
    '/api/planningMoments/bulk/periodId',
    ({ periodId, amount }, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/planningMoments/bulk/${periodId}/${amount}`, method: 'POST' }, rejectWithValue)
);

export const fetchPeriodsForBulkAdd = createAsyncThunk(
    '/api/planning/periods/departmentId',
    (departmentId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: departmentId ?
                `api/planning/periods/${departmentId}` :
                `api/planning/periods`, contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        updateSetting: { data: null, status: null },
        updateImageSetting: { data: null, status: null },
        updateNavSettings: { data: null, status: null },
        navSettings: { data: null, status: null },
        externalConnections: { data: null, status: null },
        moveImagesToAzure: { data: null, status: null },
        bulkPeriods: { data: null, status: null },
        bulkMoments: { data: null, status: null },
        adminTabIndex: 0,
        navChanged: false,
        changedThemeSettings: false,
    },
    reducers: {
        setAdminTabindex: (state, action) => {
            state.adminTabIndex = action.payload;
        },
        setChangedThemeSettings: (state, action) => {
            state.changedThemeSettings = action.payload;
        },
        resetUpdateStatus: (state) => {
            state.navChanged = false;

            ResetSliceState(state, [
                'updateSetting',
                'updateImageSetting',
                'updateNavSettings',
                'navChanged'
            ]);
        },
        resetBulkMomentsStatus: (state) => {
            ResetSliceState(state, [
                'bulkMoments'
            ]);
        },
        setNavUserRole: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].userRole = action.payload.value;
            state.navChanged = true;
        },
        setNavItemOrder: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].itemOrder = action.payload.value;
            state.navChanged = true;
        },
        setNavToggled: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].toggled = action.payload.value;
            state.navChanged = true;
        },
        setNavNavigation: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].navigation = action.payload.value;
            state.navChanged = true;
        },
        setNavTile: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].tile = action.payload.value;
            state.navChanged = true;
        },
        setNavTileButton: (state, action) => {
            const index = state.navSettings.data.findIndex((item) => item.id === action.payload.id);
            state.navSettings.data[index].tileButton = action.payload.value;
            state.navChanged = true;
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, putSetting, 'updateSetting');
        CreateAsyncStatusHandler(builder, putImageSetting, 'updateImageSetting');
        CreateAsyncStatusHandler(builder, putAllNavSettings, 'updateNavSettings');
        CreateAsyncStatusHandler(builder, fetchAllNavSettings, 'navSettings');
        CreateAsyncStatusHandler(builder, fetchExternalConnectionSettings, 'externalConnections');
        CreateAsyncStatusHandler(builder, fetchMoveImagesToAzure, 'moveImagesToAzure');
        CreateAsyncStatusHandler(builder, fetchPeriodsForBulkAdd, 'bulkPeriods');
        CreateAsyncStatusHandler(builder, postBulkMoments, 'bulkMoments');
    },
});

export const {
    setChangedThemeSettings,
    resetUpdateStatus,
    setAdminTabindex,
    setNavUserRole,
    setNavItemOrder,
    setNavToggled,
    setNavNavigation,
    setNavTile,
    setNavTileButton,
    resetBulkMomentsStatus
} = adminSlice.actions;

export default adminSlice.reducer;